// import { JsonPipe } from '@angular/common';
import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { MatPaginatorModule, PageEvent } from '@angular/material/paginator';
import { TranslateDirective } from '../Utilites/Directives/translate.directive';
import i18next from 'i18next';

@Component({
    selector: 'app-pagination',
    imports: [
        MatFormFieldModule,
        MatInputModule,
        FormsModule,
        MatPaginatorModule,
        TranslateDirective
        // JsonPipe,
    ],
    templateUrl: './pagination.component.html',
    styleUrl: './pagination.component.scss'
})
export class PaginationComponent implements OnInit {
  

  @Input() datafromparent :number | undefined ;
  @Output() onDatePicked = new EventEmitter<any>()

  length: number | undefined ;
  pageSize = 10;
  pageIndex = 0;
  pageSizeOptions = [5, 10, 25];

  hidePageSize = false;
  showPageSizeOptions = true;
  showFirstLastButtons = true;
  disabled = false;

  pageEvent!: PageEvent;

  constructor(){} 

  ngOnInit(): void {
   this.length = this.datafromparent
    this.pageEvent = {
      length:5864,
      pageIndex: this.pageIndex,
      pageSize:  this.pageSize,
      previousPageIndex:0
    }
    this.onDatePicked.emit(this.pageEvent);
  }

  handlePageEvent(e: PageEvent) {
    this.onDatePicked.emit(e);
    this.pageEvent = e;
    this.length = e.length;
    this.pageSize = e.pageSize;
    this.pageIndex = e.pageIndex;
  }

  ngAfterViewInit() {
    this.translatePaginatorLabel();

    // Optional: Update if language changes
    i18next.on('languageChanged', () => {
      this.translatePaginatorLabel();
    });
  }
  
  translatePaginatorLabel() {
    const el = document.querySelector<HTMLElement>('.mat-mdc-paginator-page-size-label');
    if (el) {
      const key = el.innerText.trim();          // Use current text as translation key
      el.innerText = i18next.t(key);           // Apply translation
    }
  }
}
